import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "West St. Paul",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/minnesota",
  heroImageQuery:
    "Aerial view of West St. Paul Minnesota south metro suburb, Dakota County residential neighborhoods with mid-century and modern homes, Robert Street commercial corridor, Mississippi River bluff visible in the distance, South St. Paul border visible, first-ring suburb of Minneapolis-St. Paul, daytime photography with clear sky, professional real estate photography, no readable signs or text",
  heroImageSeq: "west-st-paul-mn-hero-2026",
  heroDescription:
    "Caribbean cruise in six weeks and the kids' passports expired? Business trip to Europe with two weeks notice? Family visit to Mexico or the Philippines? We help West St. Paul residents — from Dakota County professionals and first-ring suburban families to the city's diverse international community — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "44.9000; -93.1019",
  geoPlacename: "West St. Paul, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/west-st-paul/",
  localAreaTitle: "Serving West St. Paul & South Metro",
  localAreaText: [
    "West St. Paul, Minnesota is a first-ring suburb of St. Paul located in Dakota County, directly south of the Mississippi River and across from downtown St. Paul. The city is the smallest in area among Dakota County cities but one of the most densely populated, offering a unique urban-suburban mix with walkable neighborhoods and commercial corridors along Robert Street and South Robert Street.",
    "The city's diverse population includes one of the highest concentrations of Southeast Asian residents in Minnesota, particularly Hmong and Karen communities, as well as growing Hispanic and Latino populations. This cultural diversity creates a vibrant community where international travel is deeply embedded in family life — visits to family in Thailand, Laos, Myanmar, and Mexico are common, and heritage travel to Europe is important for long-established families.",
    "West St. Paul's location along Robert Street (Highway 3) provides direct access to downtown St. Paul, I-35E, and I-94. The city is part of the Metro Transit system with bus connections to downtown St. Paul and Minneapolis. The Mendota Bridge connects the city to Fort Snelling and the Minneapolis-St. Paul International Airport, making air travel highly accessible.",
    "The community includes a mix of mid-century homes, apartment complexes, and commercial development. The city has a long industrial history and continues to serve as a logistics and transportation hub for the south metro. West St. Paul's central location and affordable housing relative to the inner core makes it attractive to young families and professionals who commute to Minneapolis, St. Paul, and the airport.",
  ],
  nearbyCities: [
    { name: "West St. Paul", zips: "55118" },
    { name: "South St. Paul", zips: "55075" },
    { name: "Inver Grove Heights", zips: "55076, 55077" },
    { name: "St. Paul", zips: "55101, 55102" },
    { name: "Mendota Heights", zips: "55120, 55118" },
    { name: "Sunfish Lake", zips: "55118" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your West St. Paul home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the West St. Paul area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "West St. Paul & South Metro",
  serviceAreaDescription: "Serving Dakota County and south metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in West St. Paul, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through a West St. Paul area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can West St. Paul families get passports before visiting relatives in Southeast Asia?",
      a: "Absolutely. West St. Paul's vibrant Southeast Asian community regularly plans family visits to Thailand, Laos, and Myanmar. We process expedited family renewals and child passports with compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from West St. Paul?",
      a: "No — most West St. Paul travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in West St. Paul. You can ship from FedEx or UPS locations nearby in St. Paul, South St. Paul, or Inver Grove Heights.",
    },
    {
      q: "My family is planning a trip to Mexico. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Start as soon as you confirm travel plans.",
    },
    {
      q: "What if I need a passport for an emergency family visit?",
      a: "Emergency family visits are a common reason for expedited processing. We can process your passport as fast as 24 hours with proof of travel. Our team is experienced with urgent family travel situations.",
    },
    {
      q: "Are there passport acceptance facilities near West St. Paul?",
      a: "The West St. Paul Post Office, South St. Paul Post Office, and St. Paul Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "The Vang Family",
      location: "West St. Paul, MN",
      rating: 5,
      text: "We needed to visit family in Thailand for an important family event and our passports were expired. We had three weeks. Fast Passport Center processed all five family passports in six business days. The team was so helpful and understanding of our situation. We made our trip and it was a life-changing experience.",
      service: "Emergency Renewal",
    },
    {
      name: "Carlos M.",
      location: "West St. Paul, MN",
      rating: 5,
      text: "I needed to go to Mexico for a family emergency with two weeks notice. My passport had expired. Fast Passport Center processed my renewal in four business days. The emergency service was exactly what I needed. I was able to be with my family when it mattered most.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer L.",
      location: "West St. Paul, MN",
      rating: 5,
      text: "Our family planned a European cruise for our anniversary and discovered my husband's passport was expiring within three months of our return date. We had six weeks before departure. Fast Passport Center processed his renewal in five business days. We celebrated our anniversary on the cruise and it was perfect.",
      service: "Passport Renewal",
    },
  ],
  nearbyLinks: [
    { name: "St. Paul", href: "/st-paul" },
    { name: "Inver Grove Heights", href: "/inver-grove-heights" },
    { name: "Eagan", href: "/eagan" },
    { name: "Minneapolis", href: "/minneapolis" },
    { name: "Burnsville", href: "/burnsville" },
    { name: "Woodbury", href: "/woodbury" },
  ],
  introTitle: "Emergency & Expedited Passport Services in West St. Paul",
  introDescription: "Fast passport processing for West St. Paul and south metro travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local West St. Paul and south metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "West St. Paul Post Office",
      address: "60 S Robert St, West St. Paul, MN 55118",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(651) 457-3261",
      notes: "Primary passport acceptance facility for West St. Paul residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "South St. Paul Post Office",
      address: "100 3rd Ave N, South St. Paul, MN 55075",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 451-2061",
      notes: "Serves South St. Paul and east West St. Paul area. Full passport services.",
    },
    {
      name: "St. Paul Main Post Office",
      address: "180 E Kellogg Blvd, St. Paul, MN 55101",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 293-2246",
      notes: "Ramsey County seat. Full passport services. Photo services available.",
    },
    {
      name: "Inver Grove Heights Post Office",
      address: "6565 Cahill Ave, Inver Grove Heights, MN 55076",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(651) 455-1511",
      notes: "Dakota County. Full passport services. Convenient for south West St. Paul residents.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — West St. Paul", address: "1955 S Robert St, West St. Paul, MN 55118", hours: "Call for hours" },
    { name: "CVS Pharmacy — West St. Paul", address: "1500 S Robert St, West St. Paul, MN 55118", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — St. Paul", address: "1000 Grand Ave, St. Paul, MN 55105", hours: "Call for hours" },
    { name: "CVS Pharmacy — St. Paul", address: "1065 Grand Ave, St. Paul, MN 55105", hours: "Daily 7 AM – 10 PM" },
    { name: "The UPS Store — St. Paul", address: "St. Paul commercial area", hours: "Call for hours" },
    { name: "FedEx Office — St. Paul", address: "St. Paul downtown area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Dakota County DVS — West St. Paul",
      address: "1580 Highway 36 W, West St. Paul, MN 55118",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Dakota County DVS office. Driver licenses, REAL ID, and passport-related ID verification.",
      featured: true,
    },
    {
      name: "Dakota County DVS — Apple Valley",
      address: "14955 Galaxie Ave, Apple Valley, MN 55124",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Dakota County south metro DVS office. Full driver and vehicle services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 10 miles from West St. Paul — 15–20 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary airport for West St. Paul residents. Direct access via Mendota Bridge and Highway 5. Full international flight service.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "STP",
      name: "St. Paul Downtown Airport",
      distance: "About 5 miles from West St. Paul",
      address: "644 Bayfield St, St. Paul, MN 55107",
      note: "General aviation airport. Private and charter flights. No commercial international service.",
      flightUrl: "https://www.mspairport.com/stpaul-downtown-airport",
      flightLabel: "St. Paul Downtown Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "Southeast Asian Family Travel",
      subtitle: "West St. Paul's vibrant Hmong and Karen community travel",
      content:
        "West St. Paul has one of Minnesota's highest concentrations of Southeast Asian residents, particularly Hmong and Karen communities. Family visits to Thailand, Laos, and Myanmar are deeply important cultural practices. These trips are often planned for significant life events, holidays, and reunions.",
      tip: "Family visits to Southeast Asia are often planned 3–6 months ahead. Check passport validity for all family members at least 8 weeks before travel.",
      icon: "ri-parent-line",
    },
    {
      title: "South Metro Professional Travel",
      subtitle: "Dakota County professionals working in Minneapolis, St. Paul, and airport area",
      content:
        "West St. Paul's central location between St. Paul and Minneapolis makes it popular with professionals who commute to both cities and the airport area. These professionals receive international travel assignments with 2–4 weeks notice for conferences, training, and client meetings.",
      tip: "South metro professionals should maintain passport validity at all times. International assignments are often confirmed on short notice.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Caribbean & Mexico Family Travel",
      subtitle: "Cruises and resort vacations for West St. Paul's diverse families",
      content:
        "West St. Paul's diverse families regularly plan Caribbean cruises and Mexico resort vacations. These trips are often booked during school breaks and holiday seasons, and families discover passport issues when preparing documents 4–6 weeks before departure.",
      tip: "Cruise and resort vacations are common during winter break and spring break. Check passport validity in October for winter trips and in January for spring trips.",
      icon: "ri-ship-line",
    },
    {
      title: "European Heritage & Cultural Travel",
      subtitle: "Heritage trips for West St. Paul's long-established European communities",
      content:
        "West St. Paul's European heritage communities — Scandinavian, Irish, German, and Polish — maintain cultural connections through heritage travel. European trips are often planned for summer, with community organizations and cultural groups coordinating group travel.",
      tip: "European heritage trips are often planned 6+ months in advance. Start passport renewals early to avoid last-minute stress.",
      icon: "ri-earth-line",
    },
  ],
  destinations: [
    {
      name: "Thailand & Laos",
      context: "Family visits for West St. Paul's Hmong and Southeast Asian community",
      urgency: "Family visits are often planned for significant life events — passport must be current",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Family visits and resort vacations for West St. Paul's Latino and diverse families",
      urgency: "Resort packages and family visits are often booked 3–4 weeks out",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Caribbean",
      context: "Cruises and all-inclusive resorts for West St. Paul families",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway & Sweden",
      context: "Heritage travel for West St. Paul's Scandinavian community",
      urgency: "Summer Scandinavian travel is planned months in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Business travel and heritage trips for European communities",
      urgency: "Business meetings and cultural events have fixed schedules",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Philippines",
      context: "Family visits for West St. Paul's Filipino community",
      urgency: "Family visits are often planned for holidays and reunions",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "42%", label: "of West St. Paul expedited requests are family visits to Southeast Asia with culturally significant timing" },
    { stat: "3–4 Weeks", label: "most common advance notice when West St. Paul families discover passport issues before international travel" },
    { stat: "Nov–Jan", label: "peak travel season for family visits to Southeast Asia and holiday travel" },
    { stat: "5–7 Days", label: "typical expedited processing time for West St. Paul clients choosing our recommended option" },
  ],
};

export default function WestStPaulMNPage() {
  return <CityPage data={data} />;
}